import { useEffect, useState } from "react";
import { Clock, Gift } from "lucide-react";

function getTimeUntilMidnight() {
    const now = new Date();
    const midnight = new Date(now);
    midnight.setHours(24, 0, 0, 0);
    const diff = midnight - now;
    const h = Math.floor(diff / 3_600_000);
    const m = Math.floor((diff % 3_600_000) / 60_000);
    const s = Math.floor((diff % 60_000) / 1000);
    return { h, m, s };
}

const pad = (n) => String(n).padStart(2, "0");

export default function CountdownStrip() {
    const [t, setT] = useState(getTimeUntilMidnight);

    useEffect(() => {
        const id = setInterval(() => setT(getTimeUntilMidnight()), 1000);
        return () => clearInterval(id);
    }, []);

    return (
        <div
            data-testid="countdown-strip"
            className="bg-cocoa text-cream text-center py-1.5 px-4 text-sm font-medium flex items-center justify-center gap-2 flex-wrap"
        >
            <Clock className="w-4 h-4 text-mexyellow shrink-0" />
            <span className="hidden sm:inline">⏰ Solo HOY:</span>
            <span className="font-display font-semibold">
                <Gift className="inline w-4 h-4 text-mexyellow mr-1" />
                regalo sorpresa GRATIS sobre $20.000
            </span>
            <span className="text-mexyellow font-mono font-bold tabular-nums" data-testid="countdown-timer">
                {pad(t.h)}:{pad(t.m)}:{pad(t.s)}
            </span>
        </div>
    );
}
